import { Modal, ModalBody, ModalHeader, Text, ThemeProvider } from '@change/ds-core-ui';

import { Translate, useI18n } from '@change-corgi/core-react/i18n';

import { usePetitionDetailsPageData } from 'src/app/pages/petitionDetails/pageContext';

import { RespondContainerSunrise } from '../RespondSunrise';

import { MobileModalContextDecorator } from './shared/MobileModalContextDecorator';
import type { MobileModalContext } from './shared/types';

const MobileRespondModalInner = ({ isOpen, setIsOpen }: { isOpen: boolean; setIsOpen: (isOpen: boolean) => void }) => {
	const { translate } = useI18n();
	const {
		data: {
			petition: { user },
		},
	} = usePetitionDetailsPageData();

	return (
		<Modal
			isOpen={isOpen}
			onOpenChange={setIsOpen}
			onClose={() => {}}
			closeButtonAriaLabel={translate('corgi.components.modal.close_button')}
			fullScreenOnMobile
			enableTransitionAnimations={false}
			data-qa="respond-modal"
		>
			<ModalHeader
				title={
					<Text fontWeight="bold">
						<Translate
							value="fe.components.petition_decision_maker_respond.you_are_decision_maker"
							replacements={{ starter_name: user.firstName }}
						/>
					</Text>
				}
			/>
			<ModalBody>
				<div className="w-full px-0.5" data-qa="respond-modal-container">
					<ThemeProvider>
						<RespondContainerSunrise hideHeading />
					</ThemeProvider>
				</div>
			</ModalBody>
		</Modal>
	);
};

export const MobileRespondModal = ({
	context,
	isOpen,
	setIsOpen,
}: {
	context: MobileModalContext;
	isOpen: boolean;
	setIsOpen: (isOpen: boolean) => void;
}) => {
	return (
		<MobileModalContextDecorator {...context}>
			<MobileRespondModalInner isOpen={isOpen} setIsOpen={setIsOpen} />
		</MobileModalContextDecorator>
	);
};
